import { Scenario, ScenarioType, Steps } from '../state/interfaces'
import {
  buyOrBringPhoneQuickSearch,
  howManyCallingMinutesStep,
  howMuchDataStep,
  provincesStep,
} from './quick-search-mobile-steps'

export const quickSearchMobileScenarioA: Scenario = {
  id: 'quick-search-mobile-scenario-a',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.QUICK_SEARCH_MOBILE,
  version: '1',
  milestones: [provincesStep.id, howManyCallingMinutesStep.id, howMuchDataStep.id, buyOrBringPhoneQuickSearch.id],
  steps: [provincesStep, howManyCallingMinutesStep, howMuchDataStep, buyOrBringPhoneQuickSearch],
}
